module.exports = __webpack_public_path__ + "resources/img/img_docuone4_m.bede45afed86104b8cdd91dc0452d2b9.png";